/**
 * Scan feedback.
 *
 * A short beep on every successful scan and a lower buzz when the barcode is not
 * known. In a noisy shop the cashier hears the difference without looking up,
 * which is the whole point. Generated in the browser so nothing has to download.
 */

let ctx: AudioContext | null = null;

function audio(): AudioContext | null {
  if (typeof AudioContext === 'undefined') return null;
  if (!ctx) ctx = new AudioContext();
  if (ctx.state === 'suspended') void ctx.resume();
  return ctx;
}

function tone(freq: number, ms: number, volume = 0.06): void {
  const a = audio();
  if (!a) return;
  const osc = a.createOscillator();
  const gain = a.createGain();
  osc.type = 'sine';
  osc.frequency.value = freq;
  gain.gain.setValueAtTime(volume, a.currentTime);
  gain.gain.exponentialRampToValueAtTime(0.0001, a.currentTime + ms / 1000);
  osc.connect(gain).connect(a.destination);
  osc.start();
  osc.stop(a.currentTime + ms / 1000);
}

/** Item added. */
export const beepOk = () => tone(1180, 70);

/** Barcode not recognised. */
export const beepUnknown = () => {
  tone(320, 120);
  setTimeout(() => tone(240, 160), 110);
};

/** Sale completed. */
export const beepDone = () => {
  tone(880, 80);
  setTimeout(() => tone(1320, 120), 80);
};

export const beepWarn = () => tone(520, 180);
